import { Card, Collapse, Row, FormInstance, Form } from 'antd';
import React from 'react';
import FormInput from 'components/FormInput';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import BankAccountsList from './BankAccountsList';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';
import Bank from 'components/Bank';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
const { Panel } = Collapse;
export type BankAccountProps = {
  form: FormInstance;
  id: number;
  showAsModal?: boolean;
  data?: any;
};

const BankAccountCard = ({ form, id, showAsModal,data }: BankAccountProps) => {
  return (
    <>
      <Card
        title={<GetLabel label="bank-information" style={{fontWeight:'bold',paddingLeft:15}}/>}
        style={{
          width: '100%',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          marginBottom: 10,
        }}
        bordered
      >
        <Row>
          <FormInput col xs={4} name="currcode">
            <ParListSelect
              parcode="CURRENCY"
              disabled={!!id && !isNil(data?.generalData?.currcode)}
            />
          </FormInput>
        </Row>
        <Row gutter={16}>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <UtinaCard comcode="BankDetails" level={5} lg={24}>
                <Bank
                  countcode={getFieldValue('countcode')}
                  currcode={getFieldValue('currcode')}
                  bankField="bkcodemain"
                  branchField="bkbranchcodemain"
                  cbkeyField="bkaccountkeymain"
                  cbnumField="bkaccountnummain"
                  ibanField="tpibanmain"
                  bicField="tpbicmain"
                  banknameField="tpbanknamemain"
                  form={form}
                  disabled={!isNil(data?.bankAccount?.tpiban)}
                />
              </UtinaCard>
            )}
          </Form.Item>
        </Row>
      </Card>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="left"
        defaultActiveKey={['1']}
      >
        <Panel
          disabled={!id}
          header={<Title level={5} comcode="all-bank-accounts"></Title>}
          key="2"
          style={{
            marginBottom: 24,
            overflow: 'hidden',
            background: '#f7f7f7',
            border: 10,
            borderRadius: 2,
            boxShadow:
              'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          }}
        >
          <Card bordered>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <BankAccountsList
                  form={form}
                  tpid={id}
                  showAsModal={showAsModal}
                  countcode={getFieldValue('countcode')}
                  currcode={getFieldValue('currcode')}
                />
              )}
            </Form.Item>
          </Card>
        </Panel>
      </Collapse>
    </>
  );
};

export default BankAccountCard;
